import createIcon from '../../createIcon';

/**
 * @component @name Navigation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi41TDQuNSAyMC43OUw1LjIxIDIxLjVMMTIgMTguNUwxOC43OSAyMS41TDE5LjUgMjAuNzlMMTIgMi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Navigation = createIcon('Navigation', [
  [
    'path',
    { d: 'M12 2.5L4.5 20.79L5.21 21.5L12 18.5L18.79 21.5L19.5 20.79L12 2.5Z', key: '1sqx41' },
  ],
]);

export default Navigation;
